import 'reflect-metadata'
import { defineNuxtRouteMiddleware, tryUseNuxtApp } from '#app'
import { DITokens } from '@/di'

export default defineNuxtRouteMiddleware((to, from) => {
  const nuxtApp = tryUseNuxtApp()
  if (nuxtApp) {
    // toとfromが同値の場合はinitial landing = サイト外からの遷移
    const fromExternalSite = to.fullPath === from.fullPath
    nuxtApp.$container.resolve(DITokens.NavigationStore).setNavigationSource(fromExternalSite ? 'external' : 'internal')
  }
})
